import React from 'react'
import styled from 'styled-components'
import BigCheckIcon from '~/src/assets/images/big-check.svg'

// Styled component to replace makeStyles
const CheckMarkContainer = styled.div`
  height: 100px;
  margin: 56px 0 48px 0;
  text-align: center;
  width: 100%;

  & img {
    height: 100%;
  }
`

export default function CheckedBanner() {
  return (
    <CheckMarkContainer>
      <img src={BigCheckIcon} alt="checkmark" />
    </CheckMarkContainer>
  )
}
